import { AiReport, AiUserPreferences } from '../models/ai-report.model';

export interface AiReportsState {
    reports: AiReport[];
    selectedReportId: string | null;
    preferences: AiUserPreferences | null;
    isLoading: boolean;
    generationStartedAt: string | null;
}

export const aiReportsInitialState: AiReportsState = {
    reports: [],
    selectedReportId: null,
    preferences: null,
    isLoading: false,
    generationStartedAt: null,
};
